import querystring from 'querystring';

import { getConfig } from '@/shared/getEnv';
import assets from '@/__generated__/assets.json';

type ImageKey = keyof typeof assets.images;
type IconKey = keyof typeof assets.icons;
type ImageParams = {
  w?: number | string;
  width?: number | string;
  h?: number | string;
  height?: number | string;
  convert?: 'webp' | 'jpeg' | 'png';
};
type Option = ImageParams & {
  dynamic?: boolean;
  baseUrl?: string;
};

const { publicRuntimeConfig: config } = getConfig();
const cdnUrl = config.assetPrefix ? `${config.assetPrefix}/public` : '';

const defaultParams: ImageParams = {};

function makeCdnUrl(image: string, options: Option = {}) {
  const { dynamic, baseUrl, ...params } = options;

  if (dynamic || !cdnUrl) {
    return image;
  }

  if (baseUrl) {
    return `${baseUrl}${image}`;
  }

  const query = querystring.encode({ ...defaultParams, ...params });
  return `${cdnUrl}${image}?${query}`;
}

function getAsset(image?: string, options?: Option): string {
  if (typeof image === 'string') {
    return cdnUrl ? makeCdnUrl(image, options) : image;
  }

  if (image === undefined) {
    throw Error(`Asset is not found`);
  }

  return getAsset(image, options);
}

const images = (key: ImageKey, options?: Option) => {
  const image = assets.images[key];

  return getAsset(image, options);
};

const icons = (key: IconKey, options?: Option) => {
  const image = assets.icons[key];

  return getAsset(image, options);
};

const formatImgixUrl = (url: string, params: ImageParams = {}) => {
  try {
    const uri = new URL(url);
    const query = querystring.encode({ ...params });

    return `${uri.origin}${uri.pathname}?${query}`;
  } catch (error) {
    return url;
  }
};

export type { ImageKey };
export { icons, images, formatImgixUrl, getAsset };
